'use client'

import './globals.css'

type GlobalErrorProps = {
  error: Error & { digest?: string }
  retry: () => void
}

export default function GlobalError({ error, retry }: GlobalErrorProps) {
  return (
    <html lang="ko">
      <body className="min-h-screen bg-background text-foreground antialiased">
        <title>화면 오류</title>
        <main className="flex min-h-screen items-center justify-center px-6 py-12">
          <div className="w-full max-w-[520px] text-center">
            <h1 className="text-c26 font-bold tracking-[-0.03em]">
              화면을 불러오지 못했습니다
            </h1>
            <p className="mt-3 text-c14 leading-6 text-description">
              잠시 후 다시 시도해 주세요. 같은 문제가 계속되면 관리자에게 문의해
              주세요.
            </p>
            {error.digest && (
              <p className="mt-4 font-mono text-c12 text-description">
                오류 식별자: {error.digest}
              </p>
            )}
            {/* Root layout failure에서도 동작해야 하므로 core provider/component에 의존하지 않는다. */}
            <button
              type="button"
              onClick={retry}
              className="mt-7 inline-flex min-h-12 items-center justify-center rounded-field bg-point px-5 text-c14 font-bold text-inverse"
            >
              다시 시도
            </button>
          </div>
        </main>
      </body>
    </html>
  )
}
